import * as $ from 'jquery'
//import 'matchmedia-polyfill'

export var sticky = (function(options) {

    var _self = this || {};

    this.elem            = options.elem || false;
    this.container       = (typeof(options.container) === 'object' ? options.container : false);
    this.top             = 0;
    this.bottom          = 0;
    this.enabled         = true;
    this.mediaQuery      = options.mediaQuery || false;
    this.offset          = options.offset || 0;
    this.clear           = options.clear || false;
    this.fixSpacing      = options.fixSpacing || false;
    this.additional      = options.additional || false;
    this.additionalClass = options.additionalClass || 'sticky--plus';
    this.clearElem       = options.clearElem || false;

    this.initialPad = 0;



    if(!this.elem) { return false; }

    if(typeof(this.container) !== 'object') {
        console.error('`sticky` expects `container` parameter to be a DOM element. Was given `'+typeof(this.container)+'`');
        return false;
    }

    this.isEnabled = (function() {
        if(!this.mediaQuery || window.matchMedia(this.mediaQuery).matches) {
            this.enabled = true;
        } else {
            this.enabled = false;
        }

        return this.enabled;
    });

    this.getTopPosition = (function() {

        if(_self.container) {
            var rect = _self.container.getBoundingClientRect();
            _self.top = rect.top + window.pageYOffset || 0;
        }

        return _self.top;
    });

    this.getClearOffset = (function() {
      var offset = _self.offset;

      if($('body').hasClass('admin-bar') && $('#wpadminbar').length > 0) {
          offset += $('#wpadminbar').get(0).offsetHeight;
      }

      if(_self.clear) {
        offset += _self.clear.offsetHeight;
      }

      return offset;
    });

    this.getBottomPosition = (function() {
        if(_self.container) {
            var rect = _self.container.getBoundingClientRect();
            _self.bottom = rect.bottom + window.pageYOffset || 0;
        }

        return _self.bottom;
    });


    this.triggerResizeEvent = (function() {
      setTimeout(() => {
        var resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent .initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
      }, 150);
    });

    this.cssPosition = (function() {

        const width = $(_self.elem.parentNode).width(),
              offset = _self.getClearOffset();

        if(_self.additional !== false && window.pageYOffset >= (_self.top - offset + _self.additional)) {
          if(!_self.elem.classList.contains(_self.additionalClass)) {
            _self.elem.classList.add(_self.additionalClass);
            _self.triggerResizeEvent();
          }
        } else {
          if(_self.elem.classList.contains(_self.additionalClass)) {
            _self.elem.classList.remove(_self.additionalClass);
            _self.triggerResizeEvent();
          }
        }

        if(window.pageYOffset >= (_self.top - offset) && (window.pageYOffset + offset) + _self.elem.offsetHeight <= _self.bottom) {
            var stickyClear = 0;

            if(_self.clearElem && $(_self.clearElem).length > 0) {
              stickyClear = $(_self.clearElem)[0].offsetHeight;
            }

            var topPos = offset + stickyClear;

            _self.elem.style.position = 'fixed';
            _self.elem.style.top      = topPos+'px';
            _self.elem.style.width    = width+'px';

            _self.elem.classList.add('sticky');

            if(_self.fixSpacing) {

              $(_self.container).css('padding-top',_self.initialPad + _self.elem.offsetHeight + stickyClear + 'px');
            }

        } else {

            if(window.pageYOffset <= _self.top) {

              _self.reset();

            } else {
                _self.elem.style.top = _self.bottom - _self.elem.offsetHeight + 'px';
                _self.elem.style.position = 'absolute';
                _self.elem.style.width    = width+'px';

                _self.elem.classList.add('unstuck');
            }
        }

    });

    this.reset = (function() {
        if(_self.fixSpacing) {
          $(_self.container).css('padding-top','');
        }

        _self.elem.style.position = null;
        _self.elem.style.top      = null;
        _self.elem.style.width    = null;

        _self.elem.classList.remove('sticky');
        _self.elem.classList.remove('unstuck');
        _self.elem.classList.remove(_self.additionalClass);
    });

    this.setup = (function() {
        _self.getTopPosition();
        _self.getBottomPosition();

        if(_self.isEnabled()) {
            _self.cssPosition();
            _self.scroll();
        } else {
            _self.reset();
        }
    });

    this.destroy = (function() {

        _self.reset();

        window.removeEventListener('scroll', _self.scroll);
        window.removeEventListener('resize', _self.setup);
        window.removeEventListener('load',   _self.setup);
    });

    this.scroll = (function() {

        _self.getTopPosition();
        _self.getBottomPosition();

        if(_self.enabled) {
            _self.cssPosition();
        }
    });

    _self.setup();

    window.addEventListener('scroll', _self.scroll);
    window.addEventListener('resize', _self.setup);
    window.addEventListener('load',   _self.setup);
})
